import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=619f8f57&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=babel&"
export * from "./videoList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f8f57",
  null
  
)

export default component.exports